
<svg viewBox="0 0 178 66" xmlns="http://www.w3.org/2000/svg"
     [class.level-low]="batteryLevel <= 20"
     [class.level-medium]="batteryLevel > 20 && batteryLevel <= 50">
  <defs>
    <!-- Same left-to-right gradient as app-slider's track; it spans the whole inner area so the fill reveals it -->
    <linearGradient id="batteryFillGradient" x1="5" y1="0" x2="159" y2="0" gradientUnits="userSpaceOnUse">
      <stop class="fill-stop-1" offset="0"/>
      <stop class="fill-stop-2" offset="1"/>
    </linearGradient>
  </defs>
  <!-- Inner background (empty area) -->
  <rect class="inner-bg" x="5" y="5" width="154" height="56" rx="7" ry="7"/>
  <!-- Fill bar -->
  <rect class="fill" x="5" y="5" [attr.width]="154 * (batteryLevel / 100)" height="56" rx="7" ry="7"/>
  <!-- Body outline -->
  <rect class="body" x="2" y="2" width="160" height="62" rx="10" ry="10"/>
  <!-- Terminal nub -->
  <rect class="nub" x="163" y="18" width="14" height="30" rx="5" ry="5"/>
</svg>

